export default (data) => {
  if (data &&
    data._referents.CarouselCardReferents.items.length &&
    data._referents.CarouselCardReferents.items[0]._referents.CarouselReferents.items.length
  ) {
    return data._referents.CarouselCardReferents.items[0]._referents.CarouselReferents.items[0]._slug
  }
  return false
}
